<sbi-cot-back-main-top-bar></sbi-cot-back-main-top-bar>

<div class="private-page-container">
  <div class="password-change-wrapper">
    <!-- Title Section -->
    <div class="title-section">
      <p class="subtitle">
        Cambiá tu contraseña actual por una nueva contraseña.
      </p>
    </div>

    <!-- Form -->
    <form
      [formGroup]="passwordForm"
      (ngSubmit)="onSubmit()"
      class="password-form"
      [class.form-loading]="changingPassword$ | async"
    >
      <!-- Current Password -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="currentPassword"
          label="Contraseña actual"
          inputId="currentPassword"
          [errors]="currentPasswordErrors"
        ></custom-text-field>
      </div>

      <!-- New Password -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="newPassword"
          label="Nueva contraseña"
          inputId="newPassword"
          [errors]="newPasswordErrors"
        ></custom-text-field>
      </div>

      <!-- Password Validation Indicators -->
      <app-password-validation-indicators
        [passwordControl]="passwordForm.get('newPassword')!"
      ></app-password-validation-indicators>

      <!-- Repeat New Password -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="newPasswordRepeat"
          label="Repetir nueva contraseña"
          inputId="newPasswordRepeat"
          [errors]="repeatPasswordErrors"
        ></custom-text-field>
        <!-- Password match success message -->
        <p
          class="password-match-success"
          *ngIf="
            passwordForm.get('newPasswordRepeat')!.value &&
            !passwordForm.get('newPasswordRepeat')!.hasError('passwordMismatch')
          "
        >
          Las contraseñas coinciden
        </p>
      </div>

      <!-- Submit Button -->
      <div class="button-container">
        <button
          type="submit"
          class="submit-button"
          [disabled]="passwordForm.invalid || (changingPassword$ | async)"
        >
          <i
            class="pi submit-button__icon"
            [ngClass]="
              (changingPassword$ | async) ? 'pi-spin pi-spinner' : 'pi-check'
            "
          ></i>
          <span class="submit-button__text">Cambiar contraseña</span>
        </button>
      </div>
    </form>
  </div>
</div>
